import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Truncate from 'react-truncate';

// CONSTANTS
import { DisplayType } from '@/constants/watchList';

// UTILITIES
import { getPlaceholderUrl } from '@/utility/content';

// STYLES
import { EpisodeCardContainer, EpisodeCardImage } from '../styles';

function EpisodeCard({ data, fullHeight, disabled, className, displayType, onClick, loading }) {
  const { name, content, season_number, episode_number } = data;
  const hasThumbnail = !!data.image;
  const bgImageUrl = hasThumbnail ? data.image : getPlaceholderUrl({ title: data.name });
  const seasonEpisodeNumber = `S${season_number}E${episode_number}`;

  function handleClick() {
    if (!loading) {
      onClick(data);
    }
  }

  return (
    <EpisodeCardContainer
      onClick={handleClick}
      className={clsx('episode-card', className, `episode-card--${displayType}`, {
        'episode-card--disabled': disabled,
        'episode-card--fullHeight': fullHeight,
        'episode-card--loading': loading,
      })}
    >
      <div className="episode-card__img-container">
        <EpisodeCardImage
          className="episode-card__img"
          $background={{ image: bgImageUrl, size: hasThumbnail ? 'cover' : 'auto' }}
        />
      </div>
      <div className="episode-card__main-info">
        <Typography className="episode-card__title p4" color="textPrimary">
          <Truncate lines={2} ellipsis="..." trimWhitespace>
            {content.content_title} {seasonEpisodeNumber} - {name}
          </Truncate>
        </Typography>
      </div>
    </EpisodeCardContainer>
  );
}

EpisodeCard.defaultProps = {
  loading: false,
  className: '',
  displayType: DisplayType.DEFAULT,
  onClick: () => {},
};

EpisodeCard.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  data: PropTypes.object,
  fullHeight: PropTypes.bool,
  disabled: PropTypes.bool,
  displayType: PropTypes.string,
  onClick: PropTypes.func,
};

export default React.memo(EpisodeCard);
